import { makeStyles } from '@material-ui/core';
import { blue, neutral, red } from 'shared/styles/colors';

export default makeStyles({
  board: {
    height: 'inherit',
    overflow: 'auto',
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
    borderRadius: '0.75rem',
    backgroundColor: neutral.white,
    '@media screen and (width >= 1024px)': {
      gap: 0,
      flexDirection: 'row',
    },
  },
  menu: {
    minWidth: '14rem',
    width: '100%',
    padding: 0,
    display: 'flex',
    flexWrap: 'wrap',
    fontWeight: 500,
    color: neutral[80],
    '@media screen and (width >= 1024px)': {
      maxWidth: '18.5rem',
      width: 'fit-content',
      display: 'block',
    },
  },
  navOption: {
    flex: '1 1 content',
    backgroundColor: neutral[10],
    border: `1px solid ${neutral[30]}`,
    '&:hover': {
      backgroundColor: blue[20],
    },
    '&.Mui-selected': {
      color: neutral[100],
      backgroundColor: blue[10],
      '&:hover': {
        backgroundColor: neutral[10],
      },
    },
    '@media screen and (width >= 1024px)': {
      border: 'none',
    },
  },
  navOptResults: {
    whiteSpace: 'nowrap',
  },

  listingSection: {
    width: '100%',
    overflowY: 'auto',
  },
  listItemText: {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '1rem',
    '@media screen and (width >= 1024px)': {
      fontSize: '1rem',
      lineHeight: '1.25rem',
    },
  },
  outStock: {
    flex: '1 1 content',
    padding: '0.5rem 1rem',
    gap: '0.5rem',
    color: red[60],
    backgroundColor: red[10],
    borderTopLeftRadius: '0.5rem',
    '&:hover': {
      color: red[70],
      backgroundColor: red[20],
    },
    '&.Mui-selected': {
      color: neutral.white,
      backgroundColor: red[50],
      '&:hover': {
        color: neutral.white,
        backgroundColor: red[50],
      },
    },
  },
  outStockItemText: {
    fontSize: '0.875rem',
    fontWeight: 'normal',
    lineHeight: '1rem',
    '@media screen and (width >= 1024px)': {
      fontSize: '1rem',
      lineHeight: '1.25rem',
    },
  },
});
